export const VISIBLE_WITHOUT_TOOLTIP_TEXT_ROWS_COUNT = 2; // сколько элементов видно без тултипа
export const VISIBLE_IN_TOOLTIP_TEXT_ROWS_COUNT = 10; // сколько элементов видно в тултипе

export const endSlice =
  VISIBLE_WITHOUT_TOOLTIP_TEXT_ROWS_COUNT + VISIBLE_IN_TOOLTIP_TEXT_ROWS_COUNT;
export const lengthWhichVisibleEllipses = endSlice + 1;
